import { GET_CURRENCIES_SUCCESS } from '../constants/currencies';

export default (state = [], action) => {
  switch (action.type) {
    case GET_CURRENCIES_SUCCESS:
      return action.payload && action.payload.length > 0
        ? [...action.payload]
        : [...state];

    default:
      return state;
  }
};
